import { animate, state, style, transition, trigger } from "@angular/animations";

export const submenuState = trigger('submenuState', [
  state('closed', style({ opacity: 0, transform: 'translate3d(0px, -30%, 0px)', visibility: 'hidden' })),
  state('open', style({ opacity: 1, transform: 'translate3d(0px, 0em, 0px)', visibility: 'visible'})),
  transition('closed => open', animate('150ms ease-out')),
  transition('open => closed', animate('150ms 100ms ease-in')),
]);